var $697f8e526692bd95$exports = {};
$697f8e526692bd95$exports = {
  "alert": "\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435",
  "dismiss": "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u044C"
};
export { $697f8e526692bd95$exports as default };